{
  "name": "@pierre/storage",
  "version": "1.4.1",
  "description": "Pierre Git Storage SDK",
  "repository": {
    "type": "git",
    "url": "https://github.com/pierrecomputer/sdk"
  },
  "license": "MIT",
  "type": "module",
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js",
      "require": "./dist/index.cjs",
      "default": "./dist/index.js"
    }
  },
  "files": [
    "dist",
    "src"
  ],
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "prepublishOnly": "pnpm build"
  },
  "dependencies": {
    "jose": "^5.10.0",
    "snakecase-keys": "^9.0.2",
    "zod": "^3.23.8"
  },
  "devDependencies": {
    "@types/node": "^22.0.0",
    "tsup": "8.5.0",
    "typescript": "5.8.3",
    "vitest": "3.2.4"
  },
  "publishConfig": {
    "access": "public"
  }
}
